var _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlinkGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 42,
    viewBox: "0 0 35 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2289 16.0228C14.1732 15.9577 14.1361 15.874 14.1454 15.781C14.1732 15.5951 14.3773 15.4928 14.5536 15.4184C16.2331 14.7209 17.5136 13.233 18.1909 11.5405C18.8776 9.84804 19.0075 7.97887 18.8497 6.16549C18.7013 4.4637 18.2559 2.67822 17.0125 1.5065C15.797 0.353377 14.0247 0 12.3453 0C10.7122 0.00929938 8.99559 0.353377 7.78934 1.4507C6.38824 2.71542 5.94285 4.72409 5.85006 6.61186C5.76655 8.32295 5.93357 10.0712 6.58309 11.6521C7.23261 13.233 8.4203 14.6372 9.98843 15.3161C10.1833 15.3998 10.406 15.5021 10.4617 15.7067C10.5452 16.0321 10.1276 16.2553 9.80285 16.3297C8.34607 16.6645 6.86146 16.8691 5.43252 17.3154C3.99429 17.7618 2.60247 18.4965 1.69314 19.6775C0.524003 21.1933 0.292032 23.2206 0.115734 25.1362C0.0136663 26.2336 -0.0791221 27.3588 0.106455 28.4561C0.301311 29.6092 1.06218 30.0835 2.05501 30.6229C3.89223 31.6179 5.98925 32.0085 8.03987 32.2503C11.2782 32.6315 14.5629 32.6873 17.7827 32.1573C19.7591 31.8318 21.7355 31.2645 23.4242 30.1765C23.8325 29.9161 24.2407 29.6092 24.4727 29.1722C24.7325 28.6886 24.7418 28.1027 24.7325 27.5541C24.7047 26.2522 24.6026 24.9409 24.4263 23.6483C24.2407 22.2999 23.9438 20.9236 23.1551 19.817C22.2365 18.5337 20.7519 17.7618 19.2487 17.3061C17.7455 16.8505 16.1681 16.6552 14.6464 16.246C14.498 16.1995 14.3217 16.1251 14.2289 16.0228Z",
    fill: "#434341"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5069,
    cy: 29.1831,
    r: 8.08387,
    transform: "rotate(-45 22.5069 29.1831)",
    fill: "white",
    stroke: "#434341",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2234 26.4839L25.4288 31.6893",
    stroke: "#434341",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2236 31.8823L25.429 26.6769",
    stroke: "#434341",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlinkGroup);
export default __webpack_public_path__ + "static/media/unlinkGroup.ca0f7cb159276b7a19909e8641c73fec.svg";
export { ForwardRef as ReactComponent };